import script from "./Jobs.vue?vue&type=script&setup=true&lang=js"
export * from "./Jobs.vue?vue&type=script&setup=true&lang=js"

import "./Jobs.vue?vue&type=style&index=0&id=c5fa246c&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5fa246c"]])

export default __exports__